export default {
  common: {
    esg: {
      category: '카테고리',
      environment: '환경',
      society: '사회',
      governance: '거버넌스',
      other: '기타',
      comprehensive: '종합',
      // basic: '',
    },
    btn: {
      cancel: '취소',
      add: '추가',
      create: '작성',
      update: '갱신',
      apply: '적용',
      close: '닫기',
      create_new: '신규 작성',
      edit: '편집',
      detail: '상세',
      view_detail: '상세',
      delete: '삭제',
      change: '전환',
      confirm: '확인',
      clear: '조건 초기화',
      download: '다운로드',
      save: '저장',
      register: '등록',
      check_answer: '응답 확인',
      score_card_list: '스코어카드 목록',
      confirm_action: '@:common.btn.confirm',
      edit_action: '@:common.btn.edit',
      create_action: '@:common.btn.create',
      add_action: '@:common.btn.add',
      bulk_download: '일괄 다운로드',
    },
    link: {
      delete: '삭제',
      back: '돌아가기',
    },
    sentence: {
      back_to_login: '로그인으로 돌아가기',
      back_to_dashboard: '대시보드로 돌아가기',
      not_applicable: '대상 외※',
      // back_to_top: '',
    },
    switch: {
      current_language: 'Language',
    },
    filter: {
      questionnaire: '조사표/서베이',
      questionnaire_short: '@:common.filter.questionnaire',
      target_questionnaire: '대상인 조사표/서베이를 선택해 주세요',
      target_year: '대상 연도',
      target_year_text: '대상 연도를 선택해 주세요.',
      target_company: '대상 회사',
      target_company_text: '대상 회사를 선택해 주세요',
      total: '총 {total}건',
    },
    label: {
      required: '필수',
      optional: '임의',
      year: '연도',
    },
    form: {
      search_word: {
        label: '키워드 검색',
        placeholder: '@:common.placeholder.input_free',
      },
    },
    date: {
      dateFormatTemp: 'dd/MM/yyyy',
      dateTimeFormatTemp: 'dd/MM/yyyy HH:mm zzz',
      datePickerFormat: 'dd/MM/yyyy',
      datePickerPlaceholder: 'DD/MM/YYYY',
      issue_date: '발행일',
      evaluation_expires_date: '유효기한',
      answer_expires_date: '응답 기한',
      // last_updated_date: '',
    },
    error: {
      code_0005: '인증에 실패했습니다. 다시 로그인해 주세요.',
      code_0007: '필수 항목입니다.',
      code_5001: '페이지를 찾을 수 없습니다.',
      code_0001: '이미 최신 설문으로 제출 완료했습니다.',
      code_0002: '다른 단말기에서 데이터가 갱신되었으므로 갱신할 수 없습니다. 다시 불러온 후, 조작을 재실행해 주세요.',
      code_0003: '파일을 삭제할 수 없습니다. 최소한 1개의 응답을 한 후 삭제해 주세요.',
      code_0006: '이미 등록 완료된 이용자입니다.',
      code_0004: '업로드 가능한 파일 용량을 초과했습니다. 1개 파일의 용량 상한치는 50MB입니다.',
      code_9999: '예기치 못한 오류가 발생했습니다.',
    },
    evaluation: {
      title: '평가 의뢰',
      dashboard: '대시보드',
      analysis: '분석',
      list: '기업 목록',
    },
    dashboard: {
      title: '대시보드',
    },
    upload: {
      title: '조사표/서베이',
      common: '공통',
    },
    scorecard: {
      title: '스코어카드',
      list: '목록',
      detail: '상세',
      scorecard_detail: '스코어카드 세부 사항',
      answer_preview: '응답 미리보기',
      // breadcrumb_detail: '',
    },
    improvementplans: {
      title: '개선 계획',
      detail: '@:common.scorecard.detail',
      // breadcrumb_detail: '',
    },
    detailExtra: {
      title: '고급 분석',
    },
    settings: {
      title: '설정',
    },
    // default_selector: {
    //   selected_label: '',
    //   do_select:      '',
    //   do_release:     '',
    // },
    contact: {
      title: '자주 하는 질문',
    },
    logout: {
      title: '로그아웃',
    },
    industry: {
      type_1: '농림수산업',
      type_2: '광업・채석업・자갈채취업',
      type_3: '건설업(설비공사업 포함)',
      type_4: '제조업(철강・비철금속・금속제품)',
      type_5: '제조업(기계기구・전자기기 등)',
      type_6: '제조업(식품・음료・담배 등)',
      type_7: '제조업(펄프・종이・종이가공품)',
      type_8: '제조업(목재・목제품 등 가공)',
      type_9: '제조업(화학공업(의약품 포함)・섬유공업)',
      type_10: '제조업(석유・석탄・고무・플라스틱 등)',
      type_11: '제조업(인쇄업)',
      type_12: '제조업(기타)',
      type_13: '전기・가스・열공급・수도업',
      type_14: '정보통신업',
      type_15: '운수업・창고업',
      type_16: '도매업・소매업',
      type_17: '금융업・보험업',
      type_18: '부동산업',
      type_19: '학교(유치원・보육원 등 포함)',
      type_20: '숙박업・음식서비스업',
      type_21: '생활관련서비스업(세탁・이용・미용・목욕장업 등)',
      type_22: '의료・복지',
      type_23: '폐기물처리업・리사이클업',
      type_24: '자동차정비업',
      type_25: '지자체・행정기관 등',
      type_26: '기타',
    },
    scale: {
      a: '1〜29 인',
      b: '30〜99 인',
      c: '100〜499 인',
      d: '500〜999 인',
      e: '1000〜4999 인',
      f: '5000인~',
    },
    sales_amount: {
      under_1million: '1억 엔 미만',
      under_10million: '1억~10억 엔 미만',
      under_100million: '10억~100억 엔 미만',
      under_1billion: '100억~1,000억 엔 미만',
      under_10billion: '1,000억~1조 엔 미만',
      over_10billion: '1조 엔 이상~',
      not_disclose: '응답을 원하지 않음',
    },
    progress: '완료율',
    url: {
      contact: 'https://asuene.com/rating/en/form/contact',
      asuene: 'https://asuene.com/apac',
      asuene_lca: '---ja のみ表示---',
      asuene_career: 'https://asuene.com/career/biz',
      corporate: 'https://corp.asuene.com/en',
    },
    head_title: 'ASUENE ESG',
    company_name_inc: 'ASUENE Inc.',
    breakdown: '내역',
    help: '도움말',
    user_display_mode: {
      my_assessment: '자사 평가',
      supply_chain_assessment: '공급망 평가',
    },
    buyer: '평가 의뢰 기업',
    supplier: '피평가 기업',
    error_page: {
      section_one: '지정한 페이지는 존재하지 않습니다',
      section_two: 'URL을 확인해 주세요',
      to_dashboard: '대시보드로 돌아가기',
    },
    priority: {
      good: '양호',
      high: '고',
      medium: '중',
      low: '저',
    },
    priority_full_name: {
      high: '리스크 고',
      medium: '리스크 중',
      low: '리스크 저',
    },
    faq: {
      how_to_use_csv_head: '다운로드한 CSV 파일을 Excel로 열려면 아래의 순서에 따라 진행해 주세요.',
      how_to_use_csv_body_01: '1. 새로운 공백의 Excel 북을 엽니다.',
      how_to_use_csv_body_02: '2. [데이터] 탭에서 [텍스트/CSV에서]를 클릭합니다.',
      how_to_use_csv_body_03: '3. 대상인 .csv파일을 선택하고, [열기]를 클릭합니다.',
      how_to_use_csv_body_04: '4. 표시되는 데이터 내용에 문제가 없는 것을 확인합니다.',
      how_to_use_csv_body_05: '5. [불러오기]를 선택합니다.',
      how_to_use_csv_note: '※ 순서는 사용하는 OS나 Microsoft Excel의 버전에 따라 다른 경우가 있습니다.',
    },
    answer_display_status: {
      unanswered: '미응답',
      temporarily_saved: '응답 중',
      submitted: '응답 완료',
      score_rated: '평가 완료',
      ended: '종료 완료',
    },
    all: '모두',
    count: {
      // question: '',
      company: '사',
      unit: '개 항목',
      // number_of_questions_label: '',
    },
    esg_data_display_status: {
      unanswered: '@:common.answer_display_status.unanswered',
      temporarily_saved: '@:common.answer_display_status.temporarily_saved',
      // sharing: '',
      // unshared: '',
      // inviting: '',
      // viewable: '',
      // unviewable: '',
    },
    modal: {
      csv_download_mail_sended: {
        // title: '',
        message_one: '@:list_table_filter.csv_modal_sent_mail_section_one',
        message_two: '@:list_table_filter.csv_modal_sent_mail_section_two',
        message_three: '@:list_table_filter.csv_modal_sent_mail_section_three',
      },
    },
    status: '상태',
    notification: {
      send_back: {
        // title: '',
        // description_1: '',
        // description_2: '',
        comment_label: '@:buyer_scorecard.answer_rejection_modal_text',
      },
      withdraw: {
        // title: '',
        // description_1: '',
        // description_2: '',
        // comment_label: '',
      },
      download: {
        // csv_success_title: '',
        // csv_description_1: '',
        // common_description: '',
        // action: '',
        // csv_failed_title: '',
        // failed_description_1: '',
        // failed_description_2: '',
        // pdf_success_title: '',
        // pdf_description_1: '',
        // pdf_failed_title: '',
      },
      message: {
        // title: '',
        // description: '',
      },
      company_name_label: '@:esg_data.company_name',
      message_label: '@:esg_data.message',
      data_share_invitation: {
        // title: '',
        // description: '',
        // person_label: '',
        data_label: '@:esg_data.data_name',
        // description_1: '',
        // description_2: '',
        // modal_description: '',
      },
      data_share_complete: {
        // title: '',
        // description: '',
      },
      answer_remind: {
        // title: '',
        // description: '',
      },
      // empty_description_1: '',
      // empty_description_2: '',
      // title: '',
      // unread: '',
    },
    buyer_create_question: {
      // title: '',
      // create_survey: '',
      // answer_list: '',
    },
    information: {
      // not_available: '',
      // please_wait: '',
    },
    action: {
      // delete_item: '',
    },
    category_icon: {
      // no_select: '',
      // water: '',
      // waste: '',
      // ghg: '',
      // human_rights: '',
      // occupational_safety: '',
      // security: '',
      // balance_scale: '',
      // icon: '',
      // check: '',
    },
    placeholder: {
      input_free: '입력해 주세요',
      half_digits: '반각 숫자',
    },
  },
};
